exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".active,.carousel,.carousel-inner,.item,body{height:100%}.fill{width:100%;min-height:100vh;background-position:50%;background-size:cover;-o-background-size:cover}.carousel-center{padding:40vh 10%;text-align:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/client/styles/full-slider.css
 ** module id = 61
 ** module chunks = 0
 **/